import type { MantineColorsTuple } from "@mantine/core";
import { NE_THEME_VARS, type ThemeColor } from "@node-energy/ne-theme";

const themes = {
  default: NE_THEME_VARS,
  alva: {
    ...NE_THEME_VARS,
    primary: [
      "#F4F7FA",
      "#E6EDF7",
      "#D3DFEE",
      "#BFC9E1",
      "#A2B6D6",
      "#90A5C7",
      "#899EBE",
      "#6F88A6",
      "#536988",
      "#36405B"
    ],
    secondary: [
      "#FFFDE8",
      "#FFFBC4",
      "#FFF889",
      "#FFF655",
      "#FFF533",
      "#FFF323",
      "#FFF133",
      "#E5D900",
      "#BBA700",
      "#6F7000"
    ],
    success: [
      "#E9EDF3",
      "#E9EDF3",
      "#E9EDF3",
      "#E9EDF3",
      "#BAC6D9",
      "#BAC6D9",
      "#BAC6D9",
      "#BAC6D9",
      "#BAC6D9",
      "#BAC6D9"
    ]
  },
  roedl: {
    ...NE_THEME_VARS,
    primary: [
      "#E1FAF7",
      "#B6F7ED",
      "#7DF4E3",
      "#3CE7CF",
      "#10CDB4",
      "#02BAA0",
      "#00A990",
      "#007D71",
      "#005F56",
      "#003F37"
    ]
  },
  wavelr: {
    ...NE_THEME_VARS,
    primary: [
      "#F4F3FB",
      "#E2DEF6",
      "#C6BDF1",
      "#9681D2",
      "#7361B3",
      "#4E3B99",
      "#372788",
      "#2D2068",
      "#1E154A",
      "#0D0B26"
    ],
    secondary: [
      "#F5F2FF",
      "#E2D8FE",
      "#C5B5FC",
      "#A487FA",
      "#8261F1",
      "#633FE9",
      "#5335E7",
      "#3E28B7",
      "#281A8A",
      "#170C47"
    ],
    success: [
      "#F5FFF6",
      "#F5FFF6",
      "#F5FFF6",
      "#F5FFF6",
      "#0d9d69",
      "#0d9d69",
      "#0d9d69",
      "#0d9d69",
      "#0d9d69",
      "#0d9d69"
    ],
    warning: [
      "#FFF2EB",
      "#FFF2EB",
      "#FFF2EB",
      "#FFF2EB",
      "#e4902b",
      "#e4902b",
      "#e4902b",
      "#e4902b",
      "#e4902b",
      "#e4902b"
    ],
    error: [
      "#FFF2F0",
      "#FFF2F0",
      "#FFF2F0",
      "#FFF2F0",
      "#ca2828",
      "#ca2828",
      "#ca2828",
      "#ca2828",
      "#ca2828",
      "#ca2828"
    ]
  }
};

type ThemeColorSet = Record<ThemeColor, MantineColorsTuple>;

export const THEME_NAMES = Object.keys(themes);

export const getTheme = (theme: string): ThemeColorSet => {
  if (theme in themes) {
    return themes[theme];
  } else {
    return themes.default;
  }
};
